import { Tooltip } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import EditUserModal from "@/Components/modals/client/UserAccessModal/EditUserModal";
import { ACTION_BTN_HOVER_CLR } from "@/Constants/common";
import {
  deleteClientUserdata,
  fetchClientContactAlldata,
  fetchClientUserEditdata,
  fetchClientUsers,
  setClientUsersLoading,
  updatePagination,
} from "@/reducers/client_user/clientUsers";
import { fetchUserAccessCounts } from "@/reducers/client_user/userAccess";
import { TOOLTIPTEXT } from "@/utilities/CommonText";
import { showCommonToast, showErrorToast } from "@/utilities/utils";

import { DeleteConfirmation } from "../../../popconfirm/DeleteConfirmation";
import ActionIcons from "../../ActionIcons";

const Actions = () => {
  const {
    filters,
    isSelectedAll,
    selectedClientUser,
    clientUsers,
    pagination,
  } = useSelector((state) => state.clientUsers);
  const { user } = useSelector((state) => state.clientProfile);
  const dispatch = useDispatch();
  const [editLoading, setEditLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [resendEmailToClientUserLoading, setResendEmailToClientUserLoading] =
    useState(false);

  const handleReloadTable = () => {
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setClientUsersLoading(true));
    dispatch(fetchUserAccessCounts());
    dispatch(fetchClientUsers(filters));
    if (user?.is_primary_contact) {
      dispatch(fetchClientContactAlldata());
    }
  };

  const handleDeleteConfirm = () => {
    // Block deleting own account
    const isSelf = selectedClientUser.some(
      (id) => String(id) === String(user.id),
    );
    if (isSelf) {
      showErrorToast("Action not allowed: You cannot delete your own account.");
      return;
    }
    // Block deleting Agency Admin user
    const isAgencyAdmin = selectedClientUser.some((id) => {
      const u = clientUsers.find((u) => String(u.user_id) === String(id));
      return u && u.role === "Agency Admin";
    });
    if (isAgencyAdmin) {
      showErrorToast(
        "Action not allowed: The Agency Admin account cannot be deleted.",
      );
      return;
    }

    dispatch(
      deleteClientUserdata({
        clientUserId: selectedClientUser.join(","),
        callback: () => handleReloadTable(),
        loading: deleteLoading,
        setLoading: setDeleteLoading,
        isSelectedAll: isSelectedAll,
        ignoreIds: isSelectedAll
          ? clientUsers
              .filter((ele) => !selectedClientUser.includes(ele.user_id))
              .map((ele) => ele.user_id)
              .join(",")
          : {},
      }),
    );

    if (user.is_primary_contact) {
      dispatch(fetchClientContactAlldata());
    }
  };

  return (
    <div className="Actions_Wrapper">
      <EditUserModal callback={handleReloadTable} />
      <div className="tour-client-user-actions flex h-[40px] cursor-pointer overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:w-[56px] [&>*]:min-w-[56px] [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9] [&>*]:text-txtColor">
        <>
          <Tooltip title={TOOLTIPTEXT.edit}>
            <div
              className={`group ${ACTION_BTN_HOVER_CLR.lightBlue}`}
              onClick={() => {
                if (selectedClientUser.length !== 1) {
                  showCommonToast("Please select one user ", {
                    id: "no-user-selected",
                  });
                  return;
                }
                const selectedId = selectedClientUser[0];
                const selectedUser = clientUsers.find(
                  (u) => String(u.user_id) === String(selectedId),
                );
                if (String(selectedId) === String(user.id)) {
                  showErrorToast(
                    "Action not allowed: You cannot edit your own account.",
                  );
                  return;
                }
                if (selectedUser && selectedUser.role === "Agency Admin") {
                  showErrorToast(
                    "Action not allowed: The Agency Admin account cannot be modified.",
                  );
                  return;
                }
                dispatch(
                  fetchClientUserEditdata({
                    id: selectedUser.user_id,
                    loading: editLoading,
                    setLoading: setEditLoading,
                  }),
                );
              }}
            >
              <ActionIcons isLoading={editLoading} type={"edit"} />
            </div>
          </Tooltip>
          {/* selectedClientUser */}
          <Tooltip title={TOOLTIPTEXT.delete}>
            {selectedClientUser.length > 0 ? (
              <DeleteConfirmation
                selectedCount={selectedClientUser.length}
                onConfirm={handleDeleteConfirm}
                deleteLoading={deleteLoading}
                actionButtonClass={ACTION_BTN_HOVER_CLR.red}
                deleteDescriptionName="User"
              />
            ) : (
              <Tooltip title={TOOLTIPTEXT.delete}>
                <button
                  className={`group ${ACTION_BTN_HOVER_CLR.red}`}
                  onClick={() =>
                    showCommonToast(toastMessageText?.deleteUnfillesContracts, {
                      id: "no-user-selected",
                    })
                  }
                >
                  <ActionIcons isLoading={deleteLoading} type={"delete"} />
                </button>
              </Tooltip>
            )}
          </Tooltip>

          {/* resend email to client user */}
          {/* <Tooltip title={TOOLTIPTEXT.resendEmailToClientUser}>
            <div
              className={`group ${ACTION_BTN_HOVER_CLR.lightBlue}`}
              onClick={() => {
                if (selectedClientUser.length > 0) {
                  if (selectedClientUser !== "") {
                    dispatch(resendEmailToClientUser({
                      client_user_id: selectedClientUser.join(","),
                      loading: resendEmailToClientUserLoading,
                      setLoading: setResendEmailToClientUserLoading,
                      isSelectedAll: isSelectedAll,
                      ignoreIds: isSelectedAll
                        ? (
                          clientUsers
                            .filter((ele) => !selectedClientUser.includes(ele.user_id))
                            .map((ele) => ele.user_id)
                            .join(","))
                        : {}

                    }))
                  } else {
                    showCommonToast(toastMessageText.selectUnregisteredCandidate);
                  }
                } else {
                  showCommonToast(toastMessageText.noCandidateSelected, {
                    id: "no-candidate-selected",
                  });
                }
              }}
            >
              <ActionIcons isLoading={resendEmailToClientUserLoading} type={"invite"} />
            </div>
          </Tooltip> */}

          {/* {
            user.is_primary_contact ? (
              <Tooltip title={TOOLTIPTEXT.primaryContact}>
                <div
                  className={`group ${ACTION_BTN_HOVER_CLR.green}`}
                  onClick={() => {
                    dispatch(togglePrimaryModal(true))
                  }}
                >
                  <ActionIcons type={"contactPrimary"} />
                </div>
              </Tooltip>
            ) : null
          } */}
        </>
      </div>
    </div>
  );
};

export default Actions;
